import EligibilityLayout from '@src/ui/layouts/EligibilityLayout';
import ApprovalView from '@src/ui/views/offer/ApprovalView';

const Approval = () => {
    return (
        <EligibilityLayout showTrustbarV2>
            <ApprovalView />
        </EligibilityLayout>
    );
};

export default Approval;
